/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CTA_SECURITY, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import SecurityData from '../../data/SecurityData';
import ResultCtaBanner from '../ResultCtaBanner';
import { parseUtmParams } from '../../util/Urls';
import usageTracker from '../../lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CTAButton = /*#__PURE__*/memo(({
  websiteUrl
}) => {
  const lang = window.I18N_MANUAL_LANG;
  const isEn = lang === 'en';
  const alt = isEn ? '' : '-alt';
  const url = isEn ? CTA_SECURITY : LanguageCTALinks[lang];
  const parsedUtmParams = parseUtmParams();
  const handleClick = () => {
    const eventKey = isEn ? 'academyCourseClick' : 'freeGuideClick';
    const action = isEn ? 'clicked-free-lesson-link' : 'clicked-get-guide-link';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'security-section'
    });
  };
  return /*#__PURE__*/_jsx("a", {
    href: `${url}&${parsedUtmParams}`,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `results.security.cta.button${alt}`
    })
  });
});
export default (({
  websiteGrade,
  hideCTAs = false
}) => {
  const grade = websiteGrade.securityAudit.grade;
  const websiteUrl = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered security-page",
    id: "security",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-wrapper",
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "add-on-ssl"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.SECURITY_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.description"
          })
        }), !hideCTAs && /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "lock",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.security.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {
                websiteUrl: websiteUrl
              })
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "bg-blob",
          children: /*#__PURE__*/_jsx("div", {
            className: "results-section",
            children: /*#__PURE__*/_jsx(ResultSection, {
              results: SecurityData.results,
              websiteGrade: websiteGrade
            })
          })
        })]
      })
    })
  });
});